import { createRef, useEffect } from 'react'
import { useFormikContext } from 'formik'

import Datos from 'src/components/views/EscritosLexnet/components/Tramite/components/Datos/Datos'
import Destino from 'src/components/views/EscritosLexnet/components/Tramite/components/Destino/Destino'
import Adjuntos from 'src/components/views/EscritosLexnet/components/shared/components/Adjuntos/Adjuntos'
import Intervinientes from 'src/components/views/EscritosLexnet/components/shared/components/Intervinientes/Intervinientes'
import Remitente from 'src/components/views/EscritosLexnet/components/shared/components/Remitente/Remitente'

import { EscritosFormValues } from 'src/components/views/EscritosLexnet/components/shared/types/escritosFormTypes'
import { useEscritoContext } from 'src/contexts/EscritoContext/EscritoContext'
import { useLexnetStatusContext } from 'src/contexts/LexnetStatusContext'
import { FormField } from 'src/enums/Form'
import RequiredText from '../shared/components/RequiredText'
import { useEscritosFormContext } from '../shared/components/SubmitForm'
import WrapperForm, { WrapperFormRefType } from '../shared/components/WrapperForm/WrapperForm'

type TramiteFormViewPropsType = {
  section: string
}

export default function TramiteFormView({ section }: TramiteFormViewPropsType): JSX.Element {
  const { values, resetForm, setErrors, handleSubmit, submitForm } = useFormikContext<
    EscritosFormValues
  >()
  const { initialValues: initialValuesFromContext, setIsFormInitalized } = useEscritoContext()
  const { needsSendEscrito, setNeedsSendEscrito } = useLexnetStatusContext()
  const refWrapperForm = createRef<WrapperFormRefType>()

  const { setValidateAfterSubmit } = useEscritosFormContext()

  useEffect(() => {
    resetForm(initialValuesFromContext)
    // formik.setValues(initialValues)
    // validateForm()
    setErrors({})
    setIsFormInitalized(true)
    // eslint-disable-next-line
  }, [initialValuesFromContext])

  useEffect(() => {
    if (needsSendEscrito) {
      submitForm()
      setNeedsSendEscrito(false)
    }
    // eslint-disable-next-line
  }, [needsSendEscrito])

  return (
    <WrapperForm
      section={section}
      handleSubmit={e => {
        setValidateAfterSubmit(true)
        // validateForm()
        handleSubmit(e)
      }}
      onCleanForm={() => {
        setValidateAfterSubmit(false)
      }}
      ref={refWrapperForm}
    >
      <>
        <RequiredText />
        <Remitente
          componentId={`${Math.round((Math.random() + Number.EPSILON) * 100)} ${Math.round(
            (Math.random() + Number.EPSILON) * 100
          )}`}
        />
        <Destino />
        <Intervinientes
          onNewInterviniente={data => {
            refWrapperForm.current?.newInterviniente(data)
          }}
          onEditInterviniente={data => {
            refWrapperForm.current?.editInterviniente(data)
          }}
        />
        <Datos />
        {!values[FormField.ES_CORRECCION] && <Adjuntos />}
      </>
    </WrapperForm>
  )
}
